import React from 'react';
import { MuiOtpInput } from "mui-one-time-password-input";
import styles from '../Login.module.scss';

const Confirm = (props) => {
  const [value, setValue] = React.useState("");
  const handleChange = (value) => {
    setValue(value);
  };

  return (
    <div className={styles['confirm-container']}>
      <p className={styles['confirm-heading']}>
        {props.formName === 'login' ? 'inserisci il codice che ti abbiamo inviato sul telefono per poterti loggare' : 'inserisci il codice che ti abbiamo inviato sul telefono'}
      </p>
      <MuiOtpInput
        display="flex"
        style={{
          marginTop: '27px'
        }}
        gap={0}
        ispin="yes"
        length={4}
        TextFieldsProps={{ placeholder: '-' }}
        value={value}
        onChange={handleChange}
      />
      <button className={styles["submit-button"]}>
        {props.formName === 'login' ? 'effettua il login' : 'conferma registrazione'}
      </button>
    </div>
  );
};

export default Confirm;